import React from "react"
import PropTypes from "prop-types"
import Modal from "./../Modal"
import "./SidebarMobile.css"
import Link from "gatsby-link"
import Menu from "../Routes"
// import Subscribe from "../../components/Subscribe"

export class Sidebar extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			activeIdentifier: null,
			routeUrl: "/"
		}
	}
	componentDidMount () {
		window.addEventListener("scroll", this.handleScroll, true)
		this.setState({
			// isNavChange: false,
			routeUrl: window.location.pathname,
		})
	}
	handleToggle = (activeIdentifier) => {
		this.setState({ activeIdentifier })
	}
	handleActiveNav = (identifier) => {
		const { onHide } = this.props
		// this.setState({
		// })
		this.setState({
			// isNavChange: false,
			routeUrl: "/",
		})
		onHide()
		// setTimeout(() => {
		// 	this.setState({
		// 		isNavChange: true,
		// 	})
		// }, 0)
	}
	render () {
		const { show, onHide, activePathname } = this.props
		const { activeIdentifier, routeUrl } = this.state
		let activeUrl = routeUrl === "/" || routeUrl === "/home"
		return (
			<Modal direction="right" className="sidebar" show={show} onHide={onHide}>
				<Modal.Header>
					<span className="cross">
						<i onClick={onHide} className="fa fa-times" />
					</span>
					{ /*
					<div className="mobile_subscribe">
						<Subscribe />
					</div>
					*/}
				</Modal.Header>
				<Modal.Body>
					<div className="tabs">
						<ul id="mobile__tabs" className="">
							{Menu.map((item) => {
								return (
									<li key={item.id} className={`menu__text${`${activePathname}` === `#${item.identifier}` ? "-active" : ""}`}>
										{item.isDifferentPage
											? <a onClick={onHide} href={`/${item.identifier}`} className="">{item.title}</a>
											: !activeUrl
												? <Link onClick={() => this.handleActiveNav(item.title)} to={`/#${item.identifier}`}>{item.title}</Link>
												: <a onClick={() => this.handleActiveNav(item.title)} href={`/#${item.identifier}`}>{item.title}</a>}
										{item.dropdown
											? <span>
												<i onClick={() => this.handleToggle((activeIdentifier ? null : item.identifier))} className={`fa fa-angle-up ${activeIdentifier !== item.identifier ? "toggle__rotate" : ""}`}></i>
											</span> : null}
										{activeIdentifier === item.identifier
											? <div className="dropdown-content">
												{item.dropdown && item.dropdown.map((item) => {
													return item.isDifferentPage ? <div>
														<a className="" href={`/${item.identifier}`}>&#45; {item.title}</a>
													</div> : !activeUrl
														? <Link to={`/${item.identifier}`} key={item.id} className="">
															<span>&#45; {item.title}</span>
														</Link>
														: <a href={`/${item.identifier}`} key={item.id} className="">
															<span>&#45; {item.title}</span>
														</a>
												})}
											</div>
											: null}
									</li>
								)
							})}
						</ul>
					</div>
					<div className="social_icons">
						<span className="icon">
							<a rel="noopener noreferrer" href="https://www.facebook.com/Jaycee-Punching-Solution-Pvt-Ltd-427742187329739/" target="_blank" className=""><i className="fa fa-facebook"></i></a>
						</span>
						<span className="icon">
							<a rel="noopener noreferrer" href="https://twitter.com/jaycee_power" target="_blank" className=""><i className="fa fa-twitter"></i></a>
						</span>
						<span className="icon">
							<a rel="noopener noreferrer" href="https://www.linkedin.com/company/jaycee-punching-solutions-pvt-ltd/" target="_blank" className=""><i className="fa fa-linkedin"></i></a>
						</span>
						<span className="icon">
							<a rel="noopener noreferrer" href="https://www.instagram.com/jayceeenergy" target="_blank" className=""><i className="fa fa-instagram"></i></a>
						</span>
						<span className="icon">
							<a rel="noopener noreferrer" href="https://www.youtube.com/channel/UCWjyBBfhHJxgMinIWaVzmPA" target="_blank" className=""><i className="fa fa-youtube"></i></a>
						</span>
					</div>
				</Modal.Body>
			</Modal>
		)
	}
}

Sidebar.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	activePathname: PropTypes.string,
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/SidebarMobile/Sidebar.jsx